module.exports = __webpack_public_path__ + "img/ico-user-line.7582fb3c.svg";